export const select2PhoneType = {
    placeholder: "",
    allowClear: true,
    minimumResultsForSearch: -1
}

export const select2Language = {
    placeholder: "",
    allowClear: true,
    width: 'auto',
    dropdownAutoWidth: true,
    minimumInputLength: 0,
    ajax: null
}

export const select2PhonePrefix = {
    placeholder: "",
    allowClear: true,
    minimumResultsForSearch: 0
}